"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var react_dom_1 = require("react-dom");
var react_focus_on_1 = require("react-focus-on");
var theme_1 = require("../theme");
var Box_1 = require("../Box");
var Wrapper = (0, styled_components_1.default)(Box_1.Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  ", "\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  ", "\n"])), function (_a) {
    var overlay = _a.overlay;
    return overlay && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), (0, theme_1.color)("background", 0.9));
});
var Dialog = (0, styled_components_1.default)(Box_1.Box).attrs({ role: "dialog" })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var Modal = function (_a) {
    var _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, children = _a.children, overlay = _a.overlay, rest = __rest(_a, ["onClose", "children", "overlay"]);
    var appendEl = (0, react_1.useRef)(document.createElement("div"));
    var wrapperEl = (0, react_1.useRef)(null);
    var handleClick = (0, react_1.useCallback)(function (event) {
        if (event.target === wrapperEl.current) {
            onClose();
        }
    }, [onClose]);
    (0, react_1.useEffect)(function () {
        var current = appendEl.current;
        document.body.appendChild(current);
        return function () {
            document.body.removeChild(current);
        };
    }, []);
    return (0, react_dom_1.createPortal)(react_1.default.createElement(react_focus_on_1.FocusOn, { onClickOutside: onClose, onEscapeKey: onClose },
        react_1.default.createElement(Wrapper, __assign({ ref: wrapperEl, onClick: handleClick, overlay: overlay, alignItems: "center", justifyContent: "center" }, rest),
            react_1.default.createElement(Dialog, null, children))), appendEl.current);
};
exports.Modal = Modal;
exports.Modal.displayName = "Modal";
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Modal.js.map